import { useQuery } from '@tanstack/react-query';
import { apiCoursesCurrent, apiCoursesDates, apiCoursesEvents, apiCoursesHistory, apiCoursesMoodle, apiCoursesOffer, apiCoursesSize, apiEnrollCourse, } from 'common/api/srm-api';
import { COURSES_TAB_STALE_TIME_MS, HOME_STALE_TIME_MS } from './query.constants';
export const useApiCoursesSizeQuery = () => {
    // console.log('useApiCoursesSizeQuery')
    return useQuery({
        queryKey: ['coursesSize'],
        queryFn: apiCoursesSize,
        enabled: true,
        staleTime: HOME_STALE_TIME_MS,
    });
};
export const useApiCoursesOfferQuery = (enabled = true) => {
    // console.log('useApiCoursesOfferQuery')
    return useQuery({
        queryKey: ['coursesOfferList'],
        queryFn: apiCoursesOffer,
        enabled,
        staleTime: COURSES_TAB_STALE_TIME_MS,
    });
};
export const useApiCoursesCurrentQuery = (enabled = true) => {
    // console.log('useApiCoursesCurrentQuery')
    return useQuery({
        queryKey: ['coursesCurrentList'],
        queryFn: apiCoursesCurrent,
        enabled,
        staleTime: COURSES_TAB_STALE_TIME_MS,
    });
};
export const useApiCoursesHistoryQuery = (enabled = true) => {
    // console.log('useApiCoursesHistoryQuery')
    return useQuery({
        queryKey: ['coursesHistoryList'],
        queryFn: apiCoursesHistory,
        enabled,
        staleTime: COURSES_TAB_STALE_TIME_MS,
    });
};
export const useApiCoursesMoodleQuery = (enabled = true) => {
    // console.log('useApiCoursesMoodleQuery')
    return useQuery({
        queryKey: ['coursesMoodleList'],
        queryFn: apiCoursesMoodle,
        enabled,
        staleTime: COURSES_TAB_STALE_TIME_MS,
    });
};
export const useApiEnrollQuery = (id) => {
    // console.log('useApiEnrollQuery')
    return useQuery({
        queryKey: ['enrollCourseData', id],
        queryFn: () => apiEnrollCourse(id),
        enabled: true,
    });
};
export const useApiCoursesEventsQuery = () => {
    // console.log('useApiCoursesEventsQuery')
    return useQuery({
        queryKey: ['coursesEvents'],
        queryFn: apiCoursesEvents,
        enabled: true,
        staleTime: HOME_STALE_TIME_MS,
    });
};
export const useApiCoursesDatesQuery = () => {
    // console.log('useApiCoursesDatesQuery')
    return useQuery({
        queryKey: ['coursesDates'],
        queryFn: apiCoursesDates,
        enabled: true,
        staleTime: HOME_STALE_TIME_MS,
    });
};
